var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCrumbSeparator = function SvgCrumbSeparator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 4.622a.5.5 0 0 1 0 .756L1.327 8.385A.5.5 0 0 1 .5 8.007V1.993a.5.5 0 0 1 .827-.378L4.8 4.622Z",
    stroke: "#000"
  })));
};

export default SvgCrumbSeparator;